var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{staticClass:"text-center",attrs:{"show":true,"variant":"info"}},[_c('h5',[_vm._v("Bilgi")]),_c('p',[_vm._v("Misafir Rezervasyon tarihide Tur,Villa,Transfer,Araç Kiralama vb. giriş esnasında ödeme yapar.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }